var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('notifications',{attrs:{"position":"bottom left","width":"400px","classes":"prd-notification"}}),_c('top-bar'),_c('v-main',{class:{ 'prd-main-full-width': !_vm.navDrawer }},[_c('v-container',[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }